<template>

  <div v-if="show && sourcedata" :class="show && sourcedata?'display-page':'display-none'" @touchmove.prevent="moveCancel">
    <div class="flex mach-width mach-height">
      <div class="source-content flex-1 mach-height position-relative">

        <photo-preview v-if="currentsource.resourceType == 'image'" :imgsrc="currentsource.resourceCloudUrl" :is-full="true" @showmark="showSourceMark" @exitFull="exitFullScreen" />
        <div v-else-if="currentsource.resourceType=='video'" id="body-source-wrap-video-full" class="mach-width mach-height" />
        <audio-preview v-else-if="currentsource.resourceType == 'audio'" :src="currentsource.resourceCloudUrl" @showmark="showSourceMark" />
        <pdf-preview v-else-if="currentsource.resourceType == 'pdf'" canvasid="pdf-canvas" :src="currentsource.resourceCloudUrl" :is-full="true" @showmark="showSourceMark" @exitFull="exitFullScreen" />

        <div v-if="sourceMarkShowed" class="position-absolute body-source-mark">
          <div class="body-source-mark-item flex">
            <div class="body-source-mark-item-tit">
              <p class="font-size-12 font-color-white font-bold">标题</p>
            </div>
            <div class="body-source-mark-item-desc flex-1">
              <p class="font-size-12 font-color-white">{{ currentsource.resourceName }}</p>
            </div>
          </div>

          <div class="body-source-mark-item flex">
            <div class="body-source-mark-item-tit">
              <p class="font-size-12 font-color-white font-bold">资源描述</p>
            </div>
            <div class="body-source-mark-item-desc flex-1">
              <p class="font-size-12 font-color-white">{{ currentsource.description }}</p>
            </div>
          </div>

          <div v-if="currentsource.resourceType == 'image'" class="flex body-source-mark-list">
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">创作时间</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.chronicleDate || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">资源体裁</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.genre || '-' }}</p>
            </div>

            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">内容语种</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.langues || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">图像尺寸</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.sizeOfThePicture || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">图像宽高比</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.widthHeight || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">图像位深度</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.pictureBitDepth || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">图像颜色模式</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.pictureColorMode || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">纪事人物</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.personAffected || '-' }}</p>
            </div>
          </div>
          <div v-else-if="currentsource.resourceType == 'video'" class="flex body-source-mark-list">
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">创作时间</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.chronicleDate || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">资源体裁</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.genre || '-' }}</p>
            </div>

            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">视频字幕语种</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.subtitlesLangue || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">音频声道语种</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">时长</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ getDatePoor(currentsource.resourceTime) || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">画面宽高比</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.widthheight || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">编码格式</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">数据码率</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">数据帧率</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">纪事人物</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.personAffected || '-' }}</p>
            </div>
          </div>
          <div v-else-if="currentsource.resourceType == 'audio'" class="flex body-source-mark-list">
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">创作时间</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.chronicleDate || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">资源体裁</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.genre || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">声道语种</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">时长</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ getDatePoor(currentsource.resourceTime) || '-' }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">编码格式</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">数据码率</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">采样频率</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">音频位深度</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">声道数</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">纪事人物</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.resourceTime || '-' }}</p>
            </div>
          </div>
          <div v-else class="flex body-source-mark-list">
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">创作时间</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.chronicleDate }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">内容语种</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentsource.chronicleDate }}</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">文件格式</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">文件大小</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
            <div class="body-source-mark-list-item flex">
              <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">纪事人物</p>
              <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
            </div>
          </div>
        </div>
      </div>

      <div class="source-list mach-height">
        <div v-for="(source, idx) in sourcedata" :key="idx" class="body-source-list-item flex-row-align-center cursor" :class="currentIndex==idx?'body-source-list-item-sel':''" :data-index="idx" @click="sourcechange">
          <div class="body-source-list-item-icon bg-444">
            <img v-if="source.resourceType == 'audio'" src="../../assets/icon-lib-detail-audio.png" alt="">
            <img v-else-if="source.resourceType == 'pdf'" src="../../assets/icon-lib-detail-pdf.png" alt="">
            <img v-else-if="source.resourceType == 'zip'" src="../../assets/icon-lib-detail-zip.png" alt="">
            <el-image v-else-if="source.resourceType == 'image'" class=" mach-height mach-width" :src="source.resourceCloudUrl" fit="cover" :lazy="true" />
            <el-image v-else-if="source.resourceType == 'video'" class=" mach-height mach-width" :src="source.previewUrl" fit="cover" :lazy="true" />
          </div>

          <div class="body-source-list-item-info flex-1">
            <p class="font-size-14 font-color-ccc text-line-1">{{ source.resourceName }}</p>
            <!-- <p class="font-size-12 font-color-666">{{ source.type }}</p> -->
            <p v-if="source.resourceType=='image'" class="font-size-12 font-color-666 body-source-list-type">图片</p>
            <p v-else-if="source.resourceType == 'audio'" class="font-size-12 font-color-666 body-source-list-type">音频</p>
            <p v-else-if="source.resourceType == 'video'" class="font-size-12 font-color-666 body-source-list-type">视频</p>
            <p v-else-if="source.resourceType == 'pdf'" class="font-size-12 font-color-666 body-source-list-type">PDF</p>
            <p v-else-if="source.resourceType == 'zip'" class="font-size-12 font-color-666 body-source-list-type">文件</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import pdfPreview from '@/components/pdfPreview/index.vue'
import audioPreview from '@/components/audioPreview/index.vue'
import photoPreview from '@/components/photoPreview/index.vue'
const PDFJS = require('pdfjs-dist')
import flvjs from 'flv.js/dist/flv.min.js'
import DPlayer from 'dplayer'
window.flvjs = flvjs

function fomartSeconds(second) {
  var secondType = typeof second
  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)
    var hours = Math.floor(second / 3600)
    second = second - hours * 3600
    var mimute = Math.floor(second / 60)
    second = second - mimute * 60
    return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
  } else {
    return '0:00:00'
  }
}

export default {
  components: {
    photoPreview,
    audioPreview,
    pdfPreview
  },
  filters: {
    formatSecond(second = 0) {
      return fomartSeconds(second)
    },
    formatPercent(v) {
      return v * 100
    }

  },
  props: {
    previeIndex: {
      required: false,
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      sourcedata: null,
      sourceMarkShowed: false,
      imgdata: {
        scale: 1.0
      },
      currentsource: null,
      currentIndex: 0,
      show: false,
      dplayer: null,

      audio: {
        duration: 0,
        currenttime: 0,
        playing: false,
        percent: 0,
        volume: 0,
        mute: false
      },
      showmark: false
    }
  },
  created() {
  },
  methods: {
    moveCancel() {},
    showSourceMark() {
      this.sourceMarkShowed = !this.sourceMarkShowed
    },
    initvideoplayer() {
      if (this.dplayer != null) {
        this.dplayer.destroy()
        this.dplayer = null
      }
      this.dplayer = new DPlayer({
        container: document.getElementById('body-source-wrap-video-full'),
        autoplay: true,
        theme: '#23CEBC',
        loop: false,
        lang: 'zh-cn',
        screenshot: true,
        hotkey: true,
        preload: 'auto',
        mutex: true,
        video: {
          url: this.currentsource.resourceCloudUrl,
          type: 'mp4',
          pic: ''
        }
      })
    },
    showfull(data, previeIndex) {
      this.sourcedata = data
      this.previeIndex = previeIndex
      this.currentsource = this.sourcedata[this.previeIndex]
      this.currentIndex = this.previeIndex
      this.show = true
    },
    exitFullScreen() {
      document.body.style.overflow = ''
      this.show = false
      if (this.dplayer != null) {
        this.dplayer.destroy()
        this.dplayer = null
      }
    },
    sizechange(e) {
      const tp = e.currentTarget.dataset.tp
      if (tp === 'larger') {
        if (this.imgdata.scale >= 2) {
          return
        }
        this.imgdata.scale += 0.25
      } else {
        if (this.imgdata.scale <= 1) {
          return
        }
        this.imgdata.scale -= 0.25
      }
    },
    // showmark() {
    //   this.$emit('showmark')
    // },
    sourcechange(e) {
      const index = e.currentTarget.dataset.index
      if (this.currentIndex === index) {
        return
      }
      this.sourceMarkShowed = false
      this.currentIndex = index
      this.currentsource = this.sourcedata[index]
      if (this.dplayer != null) {
        this.dplayer.destroy()
        this.dplayer = null
      }
      if (this.currentsource.resourceType === 'video') {
        const that = this
        setTimeout(() => {
          that.initvideoplayer()
        }, 1000)
      }
    },
    // 音频播放
    slidetouch(e) {
      const rect = this.$refs.audioside.getBoundingClientRect()
      this.audio.percent = (e.x - rect.x) / rect.width * 100
      this.$refs.audio.pause()
      this.$refs.audio.currentTime = this.audio.duration * (e.x - rect.x) / rect.width
      this.$refs.audio.play()
    },
    onLoadedmetadata(e) {
      this.audio.duration = parseInt(e.target.duration)
      this.audio.playing = true
    },
    onPlay() {
      this.audio.playing = true
    },
    onPause() {
      this.audio.playing = false
    },
    onTimeupdate(e) {
      this.audio.currenttime = e.target.currentTime
      this.audio.percent = (this.audio.currenttime / this.audio.duration) * 100
      if (this.audio.percent >= 100) {
        this.audio.percent = 100
      }
    },
    sliderchange(v) {
      console.log(v)
      this.audio.percent = v
      this.$refs.audio.pause()
      this.$refs.audio.currentTime = this.audio.duration * v / 100
      this.$refs.audio.play()
    },
    audiomute() {
      if (this.$refs.audio.volume === 0) {
        this.$refs.audio.volume = this.audio.volume
        this.audio.mute = false
      } else {
        this.audio.volume = this.$refs.audio.volume
        this.audio.mute = true
        this.$refs.audio.volume = 0
      }
    },
    playchange() {
      if (this.audio.playing) {
        this.$refs.audio.pause()
      } else {
        this.$refs.audio.play()
      }
      this.audio.playing = !this.audio.playing
    },
    _loadFile() { // 初始化pdf
      const loadingTask = PDFJS.getDocument(this.src)
      loadingTask.promise
        .then((pdf) => {
          this.pdfDoc = pdf
          this.pdf_pages = this.pdfDoc.numPages
          this.$nextTick(() => {
            this._renderPage(1)
          })
        })
    },
    _renderPage(num) { // 渲染pdf页
      const that = this
      this.pdfDoc.getPage(num)
        .then((page) => {
          const canvas = document.getElementById('the-canvas' + num)
          const ctx = canvas.getContext('2d')
          const dpr = window.devicePixelRatio || 1
          const bsr = ctx.webkitBackingStorePixelRatio ||
              ctx.mozBackingStorePixelRatio ||
              ctx.msBackingStorePixelRatio ||
              ctx.oBackingStorePixelRatio ||
              ctx.backingStorePixelRatio || 1
          const ratio = dpr / bsr
          const viewport = page.getViewport({ scale: this.pdf_scale })

          canvas.width = viewport.width * ratio
          canvas.height = viewport.height * ratio

          canvas.style.width = viewport.width + 'px'

          that.pdf_div_width = viewport.width + 'px'

          canvas.style.height = viewport.height + 'px'

          ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
          const renderContext = {
            canvasContext: ctx,
            viewport: viewport
          }
          page.render(renderContext)
          if (this.pdf_pages > num) {
            this._renderPage(num + 1)
          }
        })
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>

  .display-page {
    background-color: #191919;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
  }

  .display-none {
    display: none;
  }

  .source-content {
    background-color: #191919;
  }

  .source-list{
    width: 280px;
    background-color: #333;
    padding: 12px 0;
    overflow: scroll;
  }

  .body-source-list-item {
    height: 70px;
    margin-top: 10px;
    padding: 10px!important;
  }

  .body-source-list-item-sel {
    background-color: #262626;
  }

  .body-source-list-item:first-child {
    margin: 0;
  }

  .body-source-list-item-info {
    margin-left: 8px;
    height: 50px;
  }

  .body-source-list-item-icon {
    width: 50px;
    height: 50px;
    overflow: hidden;
  }

  .photo-view-tool {
    top: 10px;
    height: 30px;
    justify-content: space-between;
    z-index: 100;
  }

  .photo-view-changerange {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    background-color: #000;
  }

  .photo-view-changerange img {
    margin-right: 4px;
  }

  .photo-view-changerange img:last-child {
    margin: 0;
  }

  .photo-view-mark {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background-color: #000;
    margin-left: 5px;
  }

  .photo-view-img img {
    max-width: 100%;
    max-height: 100%;
  }

  .photo-view-tit {
    height: 30px;
    border-radius: 15px;
    padding: 0 12px;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .photo-view-tit p {
    opacity: 0.8;
  }

  #body-source-wrap-video {
    width: 100%;
    height: 100%;
  }

  #body-source-wrap-audio{
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("../../assets/icon-lib-source-audiobg.png") center;
    background-repeat: no-repeat;
    background-size:  100%;
  }

  #body-source-wrap-audio .body-source-wrap-audio-progress{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
  }

  .body-source-wrap-audio-progress-slide {
    height: 40px;
    padding: 0 20px;
  }

  .body-source-wrap-audio-control {
    height: 40px;
    padding: 0 20px;
  }

  .audio-slider {
    height: 4px;
    border-radius: 2px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .audio-slider-fill {
    width: 100%;
    top: 0;
    bottom: 0;
    border-radius: 2px;
    background-color: rgba(76, 112, 232, 0.8);
    justify-content: flex-end;
  }

  .audio-slider-thumb {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #fff;
    overflow: auto;
  }

  .audio-play-time {
    height: 40px;
  }

  .audio-play-time .audio-play {
    margin-right: 14px;
  }

  .body-source-list-type {
    margin-top: 8px;
  }
  .body-source-mark {
    left: 0;
    right: 0;
    bottom: 0;
    height: 200px;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 998;
    padding: 12px 19px;
    z-index: 99;
    overflow: scroll;
  }
   .body-source-mark-list-item {
    width: 50%;
    height: 28px;
  }

  .body-mark-right-related-title p {
    line-height: 28px;
  }

  .body-source-mark-list-item-tit {
    width: 80px;
  }

  .body-source-mark-list-item-desc {
    margin-left: 50px;
  }

  .body-source-mark-item-tit {
    width: 60px;
  }

  .body-source-mark-item-tit p {
    line-height: 28px;
  }

</style>
